import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AnonymousGuardGuard } from '@shared/guard/anonymous-guard.guard';
import { ProfileComponent } from './profile/profile.component';
import { LoginPageComponent } from './login-page/login-page.component';
import { ProfileGuardGuard } from '@shared/guard/profile-guard.guard';
import { UserManageComponent } from './user-manage/user-manage.component';
import { ManagerGuardGuard } from '@shared/guard/manager-guard.guard';
import { EditTeacherInfoComponent } from './user-manage/edit-teacher-info/edit-teacher-info.component';
import { AtlasManageComponent } from '@app/auth/atlas-manage/atlas-manage.component';
import { EditLoginComponent } from '@app/auth/edit-login/edit-login.component';

export const authRoutes: Routes = [
  { path: 'login', component: LoginPageComponent, canActivate: [AnonymousGuardGuard] },
  { path: 'loginPage', component: LoginPageComponent, canActivate: [AnonymousGuardGuard] },
  { path: 'editLogin', component: EditLoginComponent },
  { path: 'users', component: UserManageComponent, canActivate: [ManagerGuardGuard] },
  { path: 'users/edit/:id', component: EditTeacherInfoComponent, canActivate: [ManagerGuardGuard] },
  { path: 'profile', component: ProfileComponent, canDeactivate: [ProfileGuardGuard] },

  // 图谱管理
  { path: 'atlas/manage', component: AtlasManageComponent },
];

@NgModule({
  imports: [RouterModule.forChild(authRoutes)],
  exports: [RouterModule],
})
export class AuthRouteModule {}
